import { useState, useEffect } from 'react';
import { PageLayout } from '@/components/PageLayout';
import { NotificationBell } from '@/components/NotificationBell';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import axios from 'axios';
import { toast } from 'sonner';

export const UserNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/notifications`, { withCredentials: true });
      setNotifications(data);
    } catch (error) {
      toast.error('Bildirimler yüklenemedi');
    }
  };

  const markAsRead = async (notificationId) => {
    try {
      await axios.put(`${API_URL}/api/notifications/${notificationId}/read`, {}, { withCredentials: true });
      fetchNotifications();
    } catch (error) {
      toast.error('Bildirim işaretlenemedi');
    }
  };

  const markAllAsRead = async () => {
    try {
      await axios.put(`${API_URL}/api/notifications/read-all`, {}, { withCredentials: true });
      toast.success('Tüm bildirimler okundu');
      fetchNotifications();
    } catch (error) {
      toast.error('İşlem başarısız');
    }
  };

  const unreadCount = notifications.filter((n) => !n.read).length;

  return (
    <PageLayout>
      
      
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0F172A]" data-testid="notifications-title">
                Bildirimler
              </h1>
              <p className="text-base text-[#595959] mt-2">
                {unreadCount > 0 ? `${unreadCount} okunmamış bildirim` : 'Tüm bildirimler okundu'}
              </p>
            </div>
            <div className="flex items-center gap-3">
              {unreadCount > 0 && (
                <Button variant="outline" onClick={markAllAsRead} data-testid="mark-all-read-button">
                  Tümünü Okundu İşaretle
                </Button>
              )}
              <NotificationBell />
            </div>
          </div>

          <div className="space-y-3" data-testid="notifications-list">
            {notifications.length === 0 ? (
              <Card className="p-8 text-center border border-[#E5E5E5]" data-testid="no-notifications">
                <p className="text-[#595959]">Bildiriminiz bulunmamaktadır</p>
              </Card>
            ) : (
              notifications.map((notif) => (
                <Card
                  key={notif.id}
                  className={`p-6 cursor-pointer border transition-colors duration-200 ${
                    notif.read
                      ? 'bg-white border-[#E5E5E5]'
                      : 'bg-[#F9F8F6] border-[#2563EB]'
                  }`}
                  onClick={() => !notif.read && markAsRead(notif.id)}
                  data-testid={`notification-${notif.id}`}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-base text-[#1A1A1A] mb-2">{notif.message}</p>
                      <p className="text-sm text-[#595959]">
                        {new Date(notif.created_at).toLocaleString('tr-TR')}
                      </p>
                    </div>
                    {!notif.read && (
                      <div className="ml-4">
                        <div className="w-2 h-2 bg-[#2563EB] rounded-full" data-testid={`unread-indicator-${notif.id}`}></div>
                      </div>
                    )}
                  </div>
                </Card>
              ))
            )}
          </div>
        </div>
      
    </PageLayout>
  );
};
